import type { SearchCompetitorsScatterResponse } from "../types";

import { X_AXIS_ID, Y_AXIS_ID } from "./scatterConfig";

const calculateMinMaxValues = (data: SearchCompetitorsScatterResponse, key: string) => {
    const values = data.Data.map((item) => item[key]).filter((val) => val !== undefined && val !== null);
    return values.length ? { min: Math.min(...values), max: Math.max(...values) } : { min: 0, max: 0 };
};

export const transformScatterData = (data: SearchCompetitorsScatterResponse) => {
    if (!data || !data.Data.length) {
        return { scatterDataItems: [], minMaxValues: {}, mainSiteData: null };
    }

    const minMaxValues = {
        x: calculateMinMaxValues(data, X_AXIS_ID),
        y: calculateMinMaxValues(data, Y_AXIS_ID),
    };
    const filteredData = data.Data.filter((item) => item[X_AXIS_ID] && item[Y_AXIS_ID]);

    return {
        scatterDataItems: filteredData.map((item) => ({
            icon: item.Favicon,
            name: item.Domain,
            data: [{ x: item[X_AXIS_ID], y: item[Y_AXIS_ID] }],
        })),
        mainSiteData: data.MainSiteTraffic,
        minMaxValues,
    };
};
